module.exports = __webpack_public_path__ + "img/news_start_pc.e56cccd4.png";